// import visible from '../util/visible';
import anime from 'animejs';
import {ChangeLogoColour} from './common.js'
import fullpage from 'fullpage.js'
// import { startLoader, finishLoader } from '../animations/loader'
import $ from 'jquery';

export const initSlider = function () {
  if ($(window).width() <= 770) {
    new fullpage('.homepage-sections', {
      autoScrolling: true,
      verticalCentered: true,
      sectionSelector: '.homepage-section',
      licenseKey: '559930C6-B76C4EFE-AA3D2084-8ED0C277',
      responsiveSlides: true,
      responsiveHeight: 850,
      responsiveWidth: 770,
      afterLoad: function () {
        setTimeout(function () {
          ChangeLogoColour();
        }, 500);
        anime({
          targets: '.homepage-section.active .about-inner *, .homepage-section.active .text *, .homepage-section.active .clients *, .homepage-sections .homepage-section.active.contact .contact-text *, .homepage-sections .homepage-section.active.contact .location-titles *, .homepage-sections .homepage-section.active.contact .location *, .homepage-sections .homepage-section.active.contact .contact-info span, .homepage-sections .homepage-section.active.contact .contact-info p, .homepage-sections .homepage-section.active.contact .arrow-link',
          translateY: 0,
          opacity: 1,
          duration: 1000,
          delay: anime.stagger(50),
          easing: 'easeInOutQuad',
        });
      },
    });
    fullpage_api.setResponsive(true); // eslint-disable-line
    console.log('Responsive mode fired')
  } else {
    new fullpage('.homepage-sections', {
      autoScrolling: true,
      verticalCentered: false,
      sectionSelector: '.homepage-section',
      licenseKey: '559930C6-B76C4EFE-AA3D2084-8ED0C277',
      responsiveHeight: 650,
      responsiveWidth: 770,
      afterLoad: function () {
        setTimeout(function () {
          ChangeLogoColour();
        }, 500);
        anime({
          targets: '.homepage-section.active .about-inner *, .homepage-section.active .text *, .homepage-section.active .clients *, .homepage-sections .homepage-section.active.contact .contact-text *, .homepage-sections .homepage-section.active.contact .location-titles *, .homepage-sections .homepage-section.active.contact .location *, .homepage-sections .homepage-section.active.contact .contact-info span, .homepage-sections .homepage-section.active.contact .contact-info p, .homepage-sections .homepage-section.active.contact .arrow-link',
          translateY: 0,
          opacity: 1,
          duration: 1000,
          delay: anime.stagger(50),
          easing: 'easeInOutQuad',
        });
      },
    });
  }
};

export default {
  init() {
    // startLoader();
    // JavaScript to be fired on the home page
    initSlider();
    // about slide tabs
    $('.homepage-section.about li.tab_1').addClass('is-active');
    $('.about-tab-titles li').on('click touchend', function () {
      var clicked = $(this).data('tab');
      $('.homepage-section.about li.is-active').removeClass('is-active');
      $('.homepage-section.about li.' + clicked).addClass('is-active');
      anime({
        targets: '.homepage-section.about li.is-active *',
        translateY: [20, 0],
        opacity: [0, 1],
        duration: 1000,
        delay: anime.stagger(100),
        easing: 'easeInOutQuad',
      });
    });


    // solutions
    $('.solutions .service').hover(function () {
      $('.solutions .service').toggleClass('inactive');
      $(this).removeClass('inactive');
    });

    $('.homepage-section.about a').click(function () {
      fullpage_api.moveTo(4, 0); // eslint-disable-line
    });

    // video
    $('.homepage-section .fingerprint, .video-modal .close, .play-video-mobile').click(function () {
      $('.homepage-section .video-modal').toggleClass('is-active');
    });

    $('.about-video_inner').click(function () {
      if ($(this).hasClass('is-active')) {
        $('.about-video_video').get(0).pause();
      } else {
        $('.about-video_video').get(0).play();
        setTimeout(function () {
          $('.about-video_pause').fadeOut();
        }, 3000);
      }
      $(this).toggleClass('is-active');
    });
    $('.about-video_inner').hover(function () {
      $('.about-video_pause').fadeIn();
      setTimeout(function () {
        $('.about-video_pause').fadeOut();
      }, 2000);
    });
  },
  finalize() {
    // finishLoader();
  }
  ,
};
